import React from 'react';
import { Viewer } from '@tencent/spaui';
import { RPCFactory } from '../../../utils/RequestUtil';

export default class CallRecordPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      detailMessage: [],
      // 图片放大预览
      showImage: false,
      imageUrl: '',
    };
    this.handleCloseImage = this.handleCloseImage.bind(this);
  }

  componentDidMount() {
    RPCFactory.componentReport
      .getConsultContent(this.props.leadsId)
      .done((data) => {
        this.setState({
          detailMessage: data.entities,
        });
      })
      .fail((code, msg) => {
        window.alert(`获取会话详情失败，失败信息：${msg}`);
      });
  }

  showImage = (e) => {
    this.setState({
      showImage: true,
      imageUrl: e.target.src,
    });
  };

  handleCloseImage() {
    this.setState({
      showImage: false,
    });
  }

  setSize = (width, height) => {
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const result = {
      width,
      height,
    };

    if (windowWidth < width + 100 || windowHeight < height + 100) {
      if (height / width < windowHeight / windowWidth) {
        result.width = windowWidth - 100;
        result.height = ((windowWidth - 100) / width) * height;
      } else {
        result.height = windowHeight - 100;
        result.width = ((windowHeight - 100) / height) * width;
      }
    }

    return result;
  };

  render() {
    return (
      <div className="session-content">
        <ul className="session-list">
          {this.state.detailMessage !== undefined &&
            this.state.detailMessage.map((item) => {
              let liClassName;
              let spanText;
              switch (item.msgFrom) {
                case 0:
                  liClassName = 'user';
                  spanText = '客户';
                  break;
                case 1:
                  liClassName = 'service';
                  spanText = '客服';
                  break;
                case 2:
                case 4:
                  liClassName = 'system';
                  spanText = '系统';
                  break;
              }
              let msgContent;
              switch (item.msgType) {
                case 1:
                  // 文本
                  msgContent = <p>{item.msgContent}</p>;
                  break;
                case 2:
                  // 图片
                  msgContent = (
                    <img src={item.msgContent} alt="" style={{ cursor: 'pointer' }} onClick={this.showImage} />
                  );
                  break;
                case 3:
                  // 富文本
                  msgContent = <p dangerouslySetInnerHTML={{ __html: item.msgContent }} />;
                  break;
              }
              return (
                <li className={liClassName}>
                  <span className="name">{spanText}</span>
                  <div className="infos">
                    <p className="time">{item.msgTime}</p>
                    <div className="des">{msgContent}</div>
                  </div>
                </li>
              );
            })}
        </ul>
        <Viewer
          setSize={this.setSize}
          show={this.state.showImage}
          url={this.state.imageUrl}
          type="image"
          onClose={this.handleCloseImage}
        />
      </div>
    );
  }
}
